
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { toast } from '@/hooks/use-toast';

interface ConfirmationCodeProps {
  confirmationCode: string;
}

const ConfirmationCode: React.FC<ConfirmationCodeProps> = ({ confirmationCode }) => {
  const copyCodeToClipboard = () => {
    navigator.clipboard.writeText(confirmationCode);
    toast({
      title: "Đã sao chép mã xác nhận",
      description: "Mã xác nhận đã được sao chép vào clipboard.",
    });
  };

  return (
    <motion.div 
      className="text-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4, duration: 0.5 }}
    >
      <p className="font-bold mb-1">Mã xác nhận tham dự</p>
      <div className="flex items-center justify-center gap-2">
        <code className="bg-blue-100 p-2 rounded text-lg font-mono text-blue-700">{confirmationCode}</code>
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Button variant="outline" size="sm" onClick={copyCodeToClipboard} className="flex items-center">
            Sao chép
          </Button>
        </motion.div>
      </div>
      <p className="text-sm text-muted-foreground mt-2">
        Vui lòng lưu lại mã QR này để xuất trình khi tham dự sự kiện
      </p>
    </motion.div>
  );
};

export default ConfirmationCode;
